module.exports = __webpack_public_path__ + "img/pantalla-3-4.284c94b4.png";